<template>
  <fieldset
    class="form-box"
    :class="{ 'form-box--shadow': shadow }"
    :disabled="loading"
  >
    <header v-if="typeof title === 'string'" class="form-box__header">
      <span v-if="typeof icon === 'string'" class="form-box__header__icon">
        <img :src="icon" alt="">
      </span>

      <h2 v-html="title" class="form-box__header__title" />
    </header>

    <div
      v-if="toggle && (typeof subheaderTitle === 'string' || typeof subheaderDesc === 'string')"
      class="form-box__subheader"
    >
      <div
        class="form-box__subheader__text"
        :class="{ 'form-box__subheader__text--actions': edit }"
      >
        <span
          v-if="typeof subheaderTitle === 'string'"
          v-html="subheaderTitle"
          class="form-box__subheader__title"
        />

        <span
          v-if="typeof subheaderDesc === 'string'"
          v-html="subheaderDesc"
          class="form-box__subheader__desc"
        />
      </div>

      <a
        v-if="edit"
        class="form-box__subheader__edit accent--text"
        @click="$emit('edit')"
      >
        {{ $t('Common.edit') }}
      </a>

      <v-switch
        v-model="switchContainer"
        class="ma-0 pa-0"
        color="success"
        :readonly="disabled"
        hide-details
      />
    </div>

    <div
      v-if="toggle && switchContainer"
      class="form-box__body"
      :class="{
        'form-box__body--border-top': toggle &&
        (typeof subheaderTitle === 'string' || typeof subheaderDesc === 'string')
      }"
    >
      <slot></slot>
    </div>

    <div
      v-if="!toggle"
      class="form-box__body"
      :class="{
        'form-box__body--border-top': toggle &&
        (typeof subheaderTitle === 'string' || typeof subheaderDesc === 'string')
      }"
    >
      <slot></slot>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'FormBox',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    subheaderTitle: {
      type: String,
      default: null
    },
    subheaderDesc: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      switchContainer: true
    }
  },
  methods: {
    handleSwitchContainerVisibility () {
      this.switchContainer = this.visible
    }
  },
  watch: {
    switchContainer (val) {
      this.$emit('toggleVisibility', val)
    },

    visible () {
      this.handleSwitchContainerVisibility()
    }
  },
  mounted () {
    this.handleSwitchContainerVisibility()
  }
}
</script>

<style lang="scss" scoped>
//     padding: 24px 24px 0;
.form-box {
  background-color: #fff;
  border: 1px solid $gray-2;
  border-radius: 4px;
  margin-bottom: 24px;

  &.form-box--shadow {
    transition: box-shadow .26s, -webkit-box-shadow .26s;

    &:hover {
      box-shadow: 0 3px 9px 0 rgba(#000, 0.2);
    }
  }
}

.form-box__header,
.form-box__subheader {
  padding: 18px 24px;
}

.form-box__header {
  border-bottom: 1px solid $gray-2;
  display: flex;
  padding: 18px 24px;
}

.form-box__subheader {
  position: relative;

  .form-box__subheader__edit {
    position: absolute;
    right: 75px;
    top: 50%;
    transform: translateY(-50%);
  }

  .v-input {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.form-box__subheader__text {
  padding-right: 60px;

  &.form-box__subheader__text--actions {
    padding-right: 110px;
  }
}

.form-box__subheader__title,
.form-box__subheader__desc {
  display: block;
}

.form-box__subheader__desc {
  font-size: 12px;
  color: $gray-6;
}

.form-box__header__icon,
.form-box__header__title {
  display: flex;
}

.form-box__header__icon {
  display: flex;
  margin-right: 8px;
  height: 24px;
  width: 24px;

  img {
    max-width: 100%;
  }
}

.form-box__header__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 800;
}

.form-box__body {
  padding: 24px;

  &.form-box__body--border-top {
    border-top: 1px solid $gray-2;
  }
}
</style>
